<template>
  <div
    @mouseenter="e => $emit('mouseenter', e)"
    @mouseleave="e => $emit('mouseleave', e)"
    @animationend="animating = false"
    :aria-label="label"
    role="button"
    @click="togglePin"
    class="pin-button"
    :class="{ 'pin-button--enabled': pinned, 'pin-button--animated': animating }"
  >
    <img class="pin-button__disabled" src="@/assets/notification-icons/pin.svg" aria-hidden="true" />
    <img class="pin-button__enabled" src="@/assets/notification-icons/pinned.svg" aria-hidden="true" />
  </div>
</template>

<script>
// A button that pins or unpins a user. Used in SearchResultUser.vue and PinnedUser.vue
import { mapActions } from 'vuex'

export default {
  name: 'PinButton',
  props: {
    initialPinId: String,
    userId: String
  },
  data() {
    return {
      animating: false,
      pinPending: false,
      pinned: this.initialPinId != null,
      pinId: this.initialPinId // we keep this state locally so we can change them without re-loading the search results
    };
  },
  watch: {
    pinned() {
      this.animating = true;

      this.$emit("onPinChanged", this.pinned)
    }
  },
  computed: {
      label() {
          return this.pinned ? "Unpin user" : "Pin user"
      }
  },
  methods: {
    ...mapActions(['createPinHandler', 'cancelPinHandler']),
    async togglePin() {
      if (this.pinPending) return;

      this.pinPending = true;

      if (!this.pinned) {
        this.pinned = true;
        const res = await this.createPinHandler([this.userId]);

        if (!res.success) {
          this.pinned = false;
        } else {
          this.pinId = res.success;
        }
      } else {
        this.pinned = false;

        const res = await this.cancelPinHandler([this.pinId, this.userId]);

        if (!res.success) {
          this.pinned = true;
        } else {
          this.pinId = null;
        }
      }

      this.pinPending = false;
    }
  }
};
</script>
<style lang="scss">
.pin-button {
  cursor: pointer;
  width: 22px;
  height: 22px;

  &__enabled {
    display: none;
  }

  &--enabled {
    .pin-button__enabled {
      display: block;
    }

    .pin-button__disabled {
      display: none;
    }
  }

  &--animated {
    animation: switch-pin 0.2s;
  }
}

@keyframes switch-pin {
  0% {
    transform: scale(1);
    animation-timing-function: ease-in;
  }
  24% {
    transform: scale(1.15);
    animation-timing-function: ease-in;
  }
  50% {
    transform: scale(0.8);
    animation-timing-function: ease-in;
  }
  93% {
    transform: scale(1);
    animation-timing-function: ease-out;
  }
}
</style>
